export default __webpack_public_path__ + "static/media/movie.b6766fd6.png";